import { apiLogin } from './apiLogin'
import { apiRegister } from './apiRegister'
import { apiResetPassword } from './apiResetPassword'
import { apiChangePassword } from './apiChangePassword'
import { apiEmailVerification } from './apiEmailVerification'

const apiAuth = {
	fetchCurrentEmployee: async (): Promise<IUserModel> => {
		const { data } = await apiCommon<IUser>('auth/api/employee/me', { method: 'GET' })
		return User(data)
	},

	setCookies: async () => {
		await apiCommon('sanctum/csrf-cookie', { method: 'GET' })
	},

	logout: async () => {
		await apiCommon('auth/api/employee/logout', { method: 'POST' })
	},
	...apiResetPassword,
	...apiLogin,
	...apiRegister,
	...apiEmailVerification,
	...apiChangePassword,
}

export { apiAuth }
